import { SETTLEMENT_ADVANCE } from '@services/permissions'

import type { Section } from '../types'

export const lineOfCreditHistorySection: Section = {
  label: 'layout:page.lineOfCredit.history',
  route: '/line-of-credit/history',
  permissions: SETTLEMENT_ADVANCE,
  segment: {
    page: 'Line of Credit - History',
  },
}

export const lineOfCreditRequestSection: Section = {
  label: 'layout:page.lineOfCredit.request',
  route: '/line-of-credit/request',
  permissions: SETTLEMENT_ADVANCE,
  segment: {
    page: 'Line of Credit - Request',
  },
}

export const lineOfCreditDetailSection: Section = {
  label: 'layout:page.lineOfCredit.detail',
  route: '/line-of-credit/history/[id]',
  permissions: SETTLEMENT_ADVANCE,
  segment: {
    page: 'Line of Credit - Detail Page',
  },
}

export const lineOfCreditSection: Section = {
  icon: 'ClockNavOutline',
  label: 'layout:page.lineOfCredit.title',
  route: '/line-of-credit/request',
  permissions: SETTLEMENT_ADVANCE,
  pages: [
    lineOfCreditRequestSection,
    lineOfCreditHistorySection,
    lineOfCreditDetailSection,
  ],
  segment: {
    page: 'Line of Credit - Request',
  },
}
